import moment from 'moment'
import React, { useEffect, useState } from 'react'
import ReactDatePicker from '../../common/ReactDatePicker/ReactDatePicker'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Button } from 'reactstrap'
import { PROSPECT_GRADE_HOT, PROSPECT_GRADE_WARM } from '../../constants/prospectStage'
import CustomReactSelect from '../../common/CustomReactSelectComponent'
import Loader from '../Loader/index'

import CustomInput from '../../common/InputGroup'
import { getSystem } from '../System/redux/SystemActions'
import useGetSupportTable from '../../hooks/useGetSupportTable'
import useGetProspectStageByDivision from '../../hooks/useGetProspectStageByDivision'
import { OPPORTUNITY_TYPE } from '../../constants/supportTypes'
import { createOpportunity, getOpportunity, opportunityEditing, updateOpportunity } from './redux/opportunitiesActions'

const initState = {
  opportunityName: '',
  expectedCloseDate: '',
  prospectStage: '',
  probability: '',
  opportunityType: '',
  amount: '',
  createdBy: '',
}

export const OpportunityForm = ({ opportunityId }) => {
  const [state, setState] = useState(initState)

  const stageOptions = useGetProspectStageByDivision()
  const opportunities = useGetSupportTable(OPPORTUNITY_TYPE)

  const [opportunityOptions, setOpportunityOptions] = useState([])

  const {
    systemData,
    createdBy,
    contactName,
    grade,
    stage,
    userId,
    contactId,
    divisionId,
    errors,
    isLoading,
    isEditing,
    opportunity,
  } = useSelector((state) => ({
    systemData: state.systemData?.system,
    createdBy: state.auth.user.name,
    contactName: state.contacts.contact.name,
    grade: state.contacts.contactDivision.grade,
    stage: state.contacts.contactDivision.stage,
    userId: state.auth.user.userId,
    contactId: state.contacts.contact.id,
    divisionId: state.contacts.contactDivision.divisionId,
    errors: state.errors,
    isLoading: state.opportunities.isLoading,
    isEditing: state.opportunities.isEditing,
    opportunity: state.opportunities.opportunity,
  }))

  useEffect(() => {
    if (opportunities && opportunities.length > 0) {
      // ['new', 'existing']
      const op = opportunities.sort((a, b) => a.id - b.id)
      setOpportunityOptions(op)
    }
  }, [opportunities])

  useEffect(() => {
    if (!isEditing) {
      setState((prev) => ({
        ...prev,
        prospectStage: stage,
        createdBy: createdBy,
      }))
    }
  }, [stage, createdBy])

  const dispatch = useDispatch()

  useEffect(() => {
    if (isEditing && opportunityId) {
      dispatch(getOpportunity(opportunityId))
    }
  }, [isEditing, opportunityId])

  useEffect(() => {
    if (!isEditing) {
      dispatch(getSystem())
    }
    return () => {
      setState(initState)
      dispatch(opportunityEditing(false))
    }
  }, [])

  useEffect(() => {
    if (isEditing && opportunity) {
      setState({
        opportunityName: opportunity.name,
        expectedCloseDate: moment(opportunity.expectedCloseDate).toDate(),
        prospectStage: opportunity.stage,
        probability: opportunity.probability,
        opportunityType: opportunity.opportunityType,
        amount: opportunity.amount,
        createdBy: opportunity.createdByName,
      })
    }
  }, [isEditing, opportunity])

  useEffect(() => {
    if (!isEditing) {
      if (systemData) {
        const days = getSystemDays(systemData)
        let expectedCloseDate = ''
        if (days > 0) {
          expectedCloseDate = new Date(moment().add(days, 'days').format('MM/DD/YYYY')) ?? ''
        }

        setState((prev) => ({
          ...prev,
          expectedCloseDate,
        }))
      }
    }
  }, [systemData])

  const getSystemDays = (system) => {
    if (grade) {
      if (grade === PROSPECT_GRADE_WARM) {
        return system[15].referralGradeWarm
      } else if (grade === PROSPECT_GRADE_HOT) {
        return system[15].referralGradeHot
      } else {
        return system[15].referralGradeCold
      }
    } else {
      // if (system) {
      //   return system[15].referralGradeCold
      // } else {
      return 0
      // }
    }
  }

  const changeHandler = (e) => {
    const { name, value } = e.target
    setState((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const dateChangeHandler = (date, name) => {
    setState((prev) => ({
      ...prev,
      [name]: date ? new Date(moment(date).format('MM/DD/YYYY')) : null,
    }))
  }

  const selectChangeHandler = (value, name) => {
    setState((prev) => ({
      ...prev,
      [name]: value?.id ?? null,
    }))
  }

  const submitHandler = () => {
    const data = {
      ...state,
      userId,
      contactId,
      divisionId,
    }
    if (isEditing && opportunityId) {
      dispatch(updateOpportunity(opportunityId, data))
    } else {
      dispatch(createOpportunity(data))
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <Row className='d-flex align-items-center'>
        <Col md={6} className={'mb-3'}>
          <CustomInput
            type={'text'}
            onChange={changeHandler}
            label={'Opportunity Name'}
            placeholder={'Opportunity name...'}
            name={'opportunityName'}
            value={state.opportunityName}
            errorMess={errors?.opportunityName}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <ReactDatePicker
            selected={state.expectedCloseDate}
            dateFormat={'MM/dd/yyyy'}
            showTimeSelect={false}
            name={'expectedCloseDate'}
            label={'Expected Close Date'}
            placeholder='mm/dd/yyyy'
            onChange={(value) => dateChangeHandler(value, 'expectedCloseDate')}
            errorMess={errors?.expectedCloseDate}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <CustomInput
            type={'text'}
            onChange={changeHandler}
            label={'Contact Name'}
            disabled
            placeholder={'Contact name...'}
            name={'contactName'}
            value={contactName}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <CustomReactSelect
            label='Prospect Stage'
            onChange={(value) => selectChangeHandler(value, 'prospectStage')}
            options={stageOptions}
            name={'prospectStage'}
            defaultValue={state.prospectStage}
            placeholder='Prospect Stage...'
            errorMess={errors?.prospectStage}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <CustomInput
            type={'text'}
            onChange={changeHandler}
            disabled
            label={'Created By'}
            placeholder={'Enter Opportunity name...'}
            name={'createdBy'}
            value={state.createdBy}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <CustomInput
            min={0}
            max={100}
            type={'number'}
            onChange={changeHandler}
            label={'Probability'}
            placeholder={'Probability %...'}
            name={'probability'}
            value={state.probability}
            errorMess={errors?.probability}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <CustomReactSelect
            label='Opportunity Type'
            onChange={(value) => selectChangeHandler(value, 'opportunityType')}
            options={opportunityOptions}
            name={'opportunityType'}
            defaultValue={state.opportunityType}
            placeholder='Opportunity Type...'
            errorMess={errors.opportunityType}
          />
        </Col>
        <Col md={6} className={'mb-3'}>
          <CustomInput
            min={0}
            type={'number'}
            onChange={changeHandler}
            label={'Amount'}
            placeholder={'Amount...'}
            name={'amount'}
            value={state.amount}
            errorMess={errors?.amount}
          />
        </Col>
      </Row>
      <hr />
      <Row className={'mt-3'}>
        <Col md='6'>
          <Button size={'sm'} className={'btn-gold'} onClick={submitHandler}>
            Save
          </Button>
        </Col>
      </Row>
    </>
  )
}
